import React from 'react';
import { Flex, Button, Text, Box, Row, Column } from '../design-system';
import styled, { css } from 'styled-components';
import { Form, Field } from 'react-final-form';

import { filter } from 'lodash';
import FieldColumn from './FieldColumn';
import { ERR_MSG, PERMISSIONS, US_STATES } from '../globalConstants';
import {
  US_CITIES,
  FOUNDATION_COLUMNS,
  MAJOR_FUNDING_CATEGORIES,
  MINOR_FUNDING_CATEGORIES,
  YEARS_,
} from '../containers/OrgSearch/constants';
import DateField from './DateField';

const US_STATES_SELECTION = US_STATES.map(({ name, abbreviation }) => ({
  value: abbreviation,
  label: name,
}));
const STATE_CITIES = [];
const stateSelected = false;

const FILTER_FIELDS = [
  {
    name: 'name',
    label: 'Foundation Name',
  },
  {
    name: 'us_state',
    label: 'State',
    component: 'select',
    options: US_STATES_SELECTION,
  },
  {
    name: 'city',
    label: 'City',
    component: 'select',
    options: STATE_CITIES,
    disabled: true,
  },
  {
    name: 'categoryMajor',
    label: 'Major Funding Category',
    component: 'select',
    options: MAJOR_FUNDING_CATEGORIES,
  },
  {
    name: 'categoryMinor',
    label: 'Minor Funding Category',
    component: 'select',
    options: MINOR_FUNDING_CATEGORIES,
    disabled: true,
  },
  {
    name: 'org_year_last',
    component: 'select',
    label: 'Has Filed 990 Since',
    options: YEARS_(1995),
    sortOptions: false,
  },
  {
    name: 'moneyAssets',
    label: 'Organizational Assets Greater Than ($)',
  },
];

const FilterItem = styled(Box)(
  ({ theme }) => css`
    background-color: ${theme.colors.primaryLight};
    color: ${theme.colors.white};
    border-radius: 8px;
  `,
);

const getCities = (us_state: string | undefined | null) => {
  if (us_state === undefined || us_state === null) {
    return [];
  }

  const found = US_STATES.find((item) => {
    return item.abbreviation === us_state;
  });
  if (!found || !US_CITIES[found.name]) {
    return [];
  }
  const fullName = found.name;

  return US_CITIES[fullName].map((item) => ({
    value: item,
    label: item,
  }));
};

const getMinorCategories = (major_category: string | undefined | null) => {
  if (major_category === undefined || major_category === null) {
    return [];
  }

  return MINOR_FUNDING_CATEGORIES[major_category];
};
interface FilterDisplayItem {
  filter: string;
  displayValue: any;
}

interface OrgSearchTableFilterProps {
  filtersToDisplay: FilterDisplayItem[];
  search?: any;
  filters?: any;
  handleSearch?: (value: any) => void;
  saveFilters: (values: any) => void;
  isOpen?: boolean;
  clearFilters: () => void;
  toggleModal?: () => void;
}

const OrgSearchTableFilter = ({
  filtersToDisplay,
  search,
  filters,
  handleSearch,
  saveFilters,
  isOpen,
  clearFilters,
  toggleModal,
}: OrgSearchTableFilterProps) => {
  return (
    <Flex p="0 36px 0 26px" flexDirection="column">
      <Flex width="100%" mb={3}>
        <Box width="100%" mr={3}>
          <Form
            title="Filters"
            isOpen={isOpen}
            onSubmit={saveFilters}
            initialValues={filters}
            buttonText="Apply Filters"
            isConfirmation={false}
            render={({ handleSubmit, values }) => (
              <form onSubmit={handleSubmit}>
                <Row>
                  {FILTER_FIELDS.map((field) => {
                    return (
                      <Column key={field.name} pb={2} width={300}>
                        <FieldColumn
                          key={field.name}
                          {...field}
                          {...(field.name === 'city' && {
                            options: getCities(values.us_state),
                            disabled: !values.us_state,
                          })}
                          {...(field.name === 'categoryMinor' && {
                            options: getMinorCategories(values.categoryMajor),
                            disabled: !values.categoryMajor,
                          })}
                        />
                      </Column>
                    );
                  })}
                </Row>

                <Button.Group mt={4} justifyContent="space-between">
                  <Button
                    type="submit"
                    variant="green"
                    style={{ height: 48, fontSize: '0.8rem' }}
                  >
                    Execute Search
                  </Button>
                </Button.Group>
              </form>
            )}
          ></Form>
        </Box>

        <Button
          onClick={clearFilters}
          variant="red"
          style={{ height: 48, fontSize: '0.8rem' }}
        >
          Clear Filters
        </Button>
      </Flex>
      {!!filtersToDisplay.length && (
        <>
          <Text fontSize="1.2rem" fontWeight={600}>
            Current Filters:
          </Text>
          <Flex mt={2}>
            {filtersToDisplay.map(({ filter, displayValue }) => (
              <FilterItem mr={2} p="5px 12px" key={filter}>
                <Text fontWeight={600} style={{ textTransform: 'capitalize' }}>
                  {FILTER_FIELDS.find((field) => field.name === filter)
                    ?.label ?? filter}
                  :{' '}
                </Text>
                {displayValue}
              </FilterItem>
            ))}
          </Flex>
        </>
      )}
    </Flex>
  );
};

export default OrgSearchTableFilter;
